import axios from 'axios';

const BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5052';

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('adminToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    r => r,
    err => {
        if (err.response?.status === 401 || err.response?.status === 403) {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            window.location.href = '/login';
        }
        return Promise.reject(err);
    }
);

export const adminLogin = (email, password) =>
    api.post('/api/admin/login', { email, password });

export const getDashboard = () => api.get('/api/admin/dashboard');
export const getUsers = (params) => api.get('/api/admin/users', { params });
export const getUser = (userId) => api.get(`/api/admin/users/${userId}`);
export const updateUser = (userId, data) => api.put(`/api/admin/users/${userId}`, data);
export const deleteUser = (userId) => api.delete(`/api/admin/users/${userId}`);
export const getAuditLogs = (params) => api.get('/api/admin/audit-logs', { params });

export const getAccessRequests = (params) => api.get('/api/access-requests', { params });
export const getAccessRequest = (id) => api.get(`/api/access-requests/${id}`);
export const reviewAccessRequest = (id, data) => api.put(`/api/access-requests/${id}/review`, data);
export const getAccessRequestStats = () => api.get('/api/access-requests/stats');
